import React from 'react';
import Layout from '@/components/layout/Layout';
import CoordinatorDashboard from '@/components/dashboard/role-specific/CoordinatorDashboard';
import CoordinatorFarmerManagement from '@/components/coordinators/CoordinatorFarmerManagement';
import CoordinatorHarvestManagement from '@/components/coordinators/CoordinatorHarvestManagement';
import CoordinatorWebApp from '@/pages/CoordinatorWebApp';

export const coordinatorRoutes = [
  {
    path: '/coordinators',
    element: <Layout><CoordinatorDashboard /></Layout>,
  },
  {
    path: '/coordinators/farmers',
    element: <Layout><CoordinatorFarmerManagement /></Layout>,
  },
  {
    path: '/coordinators/harvests',
    element: <Layout><CoordinatorHarvestManagement /></Layout>,
  },
  {
    path: '/coordinator-webapp',
    element: <CoordinatorWebApp />,
  },
];
